import React, { Suspense, lazy, useState, useEffect } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { toast } from 'react-toastify';
import ToastMgs from '../Other/ToastMgs'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import DatePicker from "react-datepicker";
import { routes } from '../../MainPage'
import "react-datepicker/dist/react-datepicker.css";
import { sundaysInMonth, getTimeStops } from '../MakeAppointment/Shedule'
import { CommonApiFun } from '../../Redux/Action/index'
import imgPlaceHolder from '../../img/evnetPlaceHolder.png';
function NewAppointment(props) {
    const dispatch = useDispatch()
    const PatientFileInfo = useSelector((state) => state.PatientFileInfo)
    const { appointment_data, fileId, patient } = PatientFileInfo


    const { available, holiday, old_patient_appoinment_fee, reserved_slot } = appointment_data
    //const maxDate = moment().add(2, 'months').format('MM-DD-YYYY');
    const [state, setState] = useState({ day: '', time: '', isloading: false })
    const [fulldDayOff, setFullDayOff] = useState([])
    var newFormate = moment(state.day).format('YYYY-MM-DD');
    var reserved_date = reserved_slot ? Object.keys(reserved_slot) : [];
    var slotDate = newFormate && reserved_date.includes(newFormate) ? reserved_date.indexOf(newFormate) : -1
    var holidayDateArr = holiday ? holiday.map((item) => (item.date)) : []
    var holidayDate = newFormate && holidayDateArr.includes(newFormate) ? holidayDateArr.indexOf(newFormate) : -1
    if (holidayDate !== -1) {
   
        var { appoinment_time } = available.days
        var { morning_end, morning_start, afternoon_end, afternoon_start } = holiday[holidayDate].time
        var timeArr = []
        if (morning_start !== "00:00" && morning_end !== "00:00") {
            timeArr.push({ start: morning_start, end: morning_end })
        } if (afternoon_end !== "00:00" && afternoon_start !== "00:00") {
            timeArr.push({ start: afternoon_start, end: afternoon_end })
        }
        var allTimes1 = getTimeStops(appoinment_time, timeArr)
      
    }
    // var holidayDate =newFormate && holidayDateArr.includes(newFormate) ? holidayDateArr.indexOf(newFormate) :-1

    // const holyDaytimeDis=newFormate && reserved_date.includes(newFormate) ? reserved_date.indexOf(newFormate) :
    var timeDis = slotDate != -1 ? reserved_slot[reserved_date[slotDate]].map((time) => (time[0])) : []
    if (newFormate == moment().format('YYYY-MM-DD')) {

        var beginningTime = "09:00"
        var endTime = moment().format("HH:mm");
     
    }
    
    const maxDate = moment().add(2, 'months').format('MM-DD-YYYY');
    var daysInWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var avilableDays = available && available.time;
    var difference = avilableDays ? daysInWeek.filter(x => !avilableDays.includes(x)) : [];
    var dayoff = []
    difference.map((item, index) => {
        dayoff.push(daysInWeek.indexOf(item))
    })
    var excludeDates = sundaysInMonth(dayoff)
    var { appoinment_time, morning_start, morning_end, afternoon_start, afternoon_end } = available ? available.days : {}
    var allTimes = available && getTimeStops(appoinment_time, [{ start: morning_start, end: morning_end }, { start: afternoon_start, end: afternoon_end }])
    const slotArr = (allTimes1 ? allTimes1 : allTimes)

    useEffect(() => {
        holiday.map((item) => {
            var { afternoon_end, afternoon_start, morning_end, morning_start } = item.time
            if (afternoon_end == "00:00" && afternoon_start == "00:00" && morning_end == "00:00" && morning_start == "00:00") {
                setFullDayOff([...fulldDayOff, new Date(item.date)])
           
            }
        })
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }

    }, [])
    // const  slotArr=["09:00","09:30","10:00","10:30"
    const handleDayClick = (day) => {
    
        setState((prev) => ({ ...prev, day: day, time: '' }))
      
        // props.handleState("day", day)
        // props.handleState("time", '')
    }
    const onSeleteTime = (item, index) => {
        var startTime = moment(item, 'HH:mm');
        if (typeof timeDis == "undefined") {
            setState((prev) => ({ ...prev, time: item, Endtime: startTime.add(appoinment_time, 'minutes').format('HH:mm') }))
            // props.handleState("time", item)
            // props.handleState("Endtime", startTime.add(appoinment_time, 'minutes').format('HH:mm'))
        } else if ((timeDis && !timeDis.includes(item))) {
            setState((prev) => ({ ...prev, time: item, Endtime: startTime.add(appoinment_time, 'minutes').format('HH:mm') }))
        }
    }
    const submitData = (e) => {

        e.preventDefault()
        let appointmentDate = props.appointmentArr.filter((a) => { if (moment(state.day).diff(moment(a.appointment_date), 'days') == 0) { return a } });
        //alert("fdjk")
        if (state.day == "" || state.time == "") {

            toast(<ToastMgs status={'failed'} message={'Please select a date and time at your convenience'} />)
        } else if (appointmentDate.length > 0) {
            // alert("fsdjkffg")
            toast(<ToastMgs status={'failed'} message={"Your appointment is already scheduled on " + moment(state.day).format('YYYY-MM-DD') + ", so you can't schedule another"} />)
            //  Your appointment is already scheduled today, so you can't schedule another
        } else {
            // alert(props.isTodayAppoitmnet.length)
            setState((prev) => ({ ...prev, isloading: true }))

          
            var data = { appointment_start_time: state.time, appointment_end_time: state.Endtime, file_id: fileId, charge: old_patient_appoinment_fee, patient_id: patient.patient_key, appointment_date: moment(state.day).format('YYYY-MM-DD') }
           
            dispatch(CommonApiFun("api/New_appointment/post", JSON.stringify(data))).then(async (res) => {
                if (res.status == "success") {
                    PaypalPaymnet(res)
                }
            }).catch((e) => { })

        }

    }
    const PaypalPaymnet = (result) => {
        
        const { key, amount, order_id, currency } = result.data;

        const options = {
            key: key,
            currency: "INR",
            amount: amount, //  = INR 1
            name: 'Ansh clinic',
            description: 'some description',
            image: imgPlaceHolder,
            order_id: order_id,
            modal: {
                "ondismiss": function () {
                    setState((prev) => ({ ...prev, isloading: false }))
                }
            },
            handler: function (response) {

                response.pid = patient.patient_key
                response.tid = result.transaction_id
                response.aid = result.appointment_id
            
                dispatch(CommonApiFun('api/payment_approve/post', JSON.stringify(response))).then(async (res) => {
                    var PatientFileInfo_ = PatientFileInfo
                    PatientFileInfo_.appointment.push({ appointment_date: moment(state.day).format('YYYY-MM-DD'), appointment_end_time: state.Endtime, appointment_start_time: state.time, appointment_by: 0 })
                    dispatch({ type: "PATIENT_FILE_INFO", payload: PatientFileInfo_ })
                    setState((prev) => ({ ...prev, day: '', time: '', isloading: false }))
                    document.body.classList.remove('show-popup');
                }).catch((e) => { alert("ksusdusdfudf"); })
            },
            prefill: {
                name: patient.first_name + " " + patient.last_name,
                contact: "91" + patient.mobile_no,
                email: patient.email,

            },
            notes: {
                address: patient.address,

            },
        };

        var rzp1 = new window.Razorpay(options);
        rzp1.open();

    }
    return (
        <>
            <div className="popup-box">
                <div className="popup-inner popup-content">
                    <div className="popup-header">
                        <h2>Schedule</h2>
                        <div className="close-btn" onClick={() => {
                            setState((prev) => ({ ...prev, day: '', time: '' }))
                            document.body.classList.remove('show-popup');

                        }}>
                            <svg
                                width={12}
                                height={12}
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 1.05L10.95 0L6 4.95L1.05 0L0 1.05L4.95 6L0 10.95L1.05 12L6 7.05L10.95 12L12 10.95L7.05 6L12 1.05Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="ppup_body booking_body">
                        <div className="main">
                            <div className="main-content">
                                {/* <input
                                    type="date"
                                    id="select-date"
                                    name="select-date"
                                    placeholder="Select Date"
                                    defaultValue="Select Date"
                                /> */}
                                <DatePicker
                                    selected={state.day !== "" && state.day}

                                    excludeDates={[...excludeDates, ...fulldDayOff]}

                                    minDate={new Date()}
                                    maxDate={new Date(maxDate)}
                                    placeholderText="Select date"
                                    dateFormat="yyyy-MM-dd"
                                    onChange={handleDayClick}
                                // className='btn btn-submit'
                                />
                                <>
                                    <div className="slots_info">
                                        <p>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 359.286 359.286"
                                            >
                                                <path d="m179.643 359.286c99.043 0 179.643-80.6 179.643-179.643s-80.599-179.643-179.643-179.643-179.643 80.6-179.643 179.643 80.6 179.643 179.643 179.643zm0-335.334c85.869 0 155.691 69.821 155.691 155.691s-69.821 155.691-155.691 155.691-155.691-69.821-155.691-155.691 69.822-155.691 155.691-155.691z" />
                                                <path d="m232.039 236.89c2.216 1.796 4.85 2.635 7.485 2.635 3.533 0 7.006-1.557 9.341-4.491 4.132-5.15 3.293-12.695-1.856-16.827l-55.39-44.312v-90.061c0-6.587-5.389-11.976-11.976-11.976s-11.976 5.389-11.976 11.976v95.81c0 3.653 1.677 7.066 4.491 9.341z" />
                                            </svg>
                                            Info about available timeslots
                                        </p>
                                        <div className="slots_slab">
                                            <div className="slots_time available_slot">
                                                <span>Available time Slots</span>
                                            </div>
                                            <div className="slots_time selected_slot">
                                                <span>selected time Slots</span>
                                            </div>
                                            <div className="slots_time booked_slot">
                                                <span>Booked time Slots</span>
                                            </div>
                                        </div>
                                    </div>
                                    {<div className="slots">
                                        <ul>
                                            {slotArr && slotArr.map((item, index) => (
                                                <>
                                                    <li className={` ${(timeDis.includes(item) || state.day == "") ? "disable" : ''} ${newFormate == moment().format('YYYY-MM-DD') && moment().format("HH:mm") > item ? "disable" : ''} ${item == state.time ? "selected" : ''}`} onClick={() => {
                                                        onSeleteTime(item, index)
                                                    }}>{item} <span>{moment(item, "hh:mm").format('LT')}</span></li>

                                                    {/* {<div className={`inner ${(timeDis.includes(item)) ? "slot-time-dis" : ''} ${newFormate == moment().format('YYYY-MM-DD') && moment().format("HH:mm") > item ? "slot-time-dis" : ''} ${item == time ? "slot-time-active" : ''}`} onClick={() => {
                                        onSeleteTime(item, index)
                                    }} key={index}>
                                        <p className="slot-time-no">{index + 1}</p>
                                        <p className="slot-time-no">{item}</p>
                                    </div>} */}
                                                </>
                                            ))}
                                        </ul>
                                    </div>}

                                </>
                            </div>
                            <div className="buttons button_space">
                                <button className={`btn next_button btn-relative ${state.isloading ? 'btn--loading' : ''}`} onClick={(e) => { submitData(e) }}>
                                    <span className="btn-text">Payment</span>
                                    <span className="btn__loader">
                                        <div
                                            role="progressbar"
                                            aria-valuemin={0}
                                            aria-valuemax={100}
                                            className="progress-circular progress-circular--visible progress-circular--indet"
                                            style={{ height: 23, width: 23 }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381"
                                                style={{ transform: "rotate(0deg)" }}
                                            >
                                                <circle
                                                    fill="transparent"
                                                    cx="43.80952380952381"
                                                    cy="43.80952380952381"
                                                    r={20}
                                                    strokeWidth="3.8095238095238093"
                                                    strokeDasharray="125.664"
                                                    strokeDashoffset="125.66370614359172px"
                                                    className="progress-circular__overlay"
                                                />
                                            </svg>
                                        </div>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    );
}

export default NewAppointment;